import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Grid } from "@mui/material";
import NavLogoFooter from "../../assets/images/logo/NavLogo_new.png";
import axios from "axios";
import { BrandingContext } from "../../BrandingProvider";

const FooterPdfTemplate = () => {
  const [departments, setDepartments] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  // Access branding data from the context
  const brandingData = useContext(BrandingContext);

  //   // Find the "branding_statements.json" item and extract the themeColour
  //   const brandingItem = brandingData?.find(
  //     (item) => item.name === "branding_statements.json"
  //   );
  //   const themeColour = brandingItem?.content?.themeColour || "#21cdc0"; // Fallback to default color if not found
  // Function to decode base64 to JSON
  // function decodeBase64ToJson(base64String) {
  //     try {
  //       // Decode base64 and parse the JSON string
  //       const jsonString = atob(base64String);
  //       return JSON.parse(jsonString);
  //     } catch (error) {
  //       console.error("Failed to decode base64 or parse JSON", error);
  //       return null;
  //     }
  //   }

  //   // Find the 'collateral_image.png'
  //   const collateralImage =
  //     brandingData?.find((item) => item.name === "collateral_image.png")?.content || null;

  //   // Find the 'branding_statements.json' and decode its base64 content
  //   const brandingItem = brandingData?.find((item) => item.name === "branding_statements.json");
  //   const brandingContent = brandingItem ? decodeBase64ToJson(brandingItem.content) : null;

  //   // Extract the 'collateralBrandStatement' and 'themeColour' from decoded JSON
  //   const collateralBrandStatement = brandingContent?.collateralBrandStatement || null;
  //   const themeColour = brandingContent?.themeColour || "#21cdc0";

  //   // Log the results for verification
  //   console.log("Collateral Image:", collateralImage);
  //   console.log("Collateral Brand Statement:", collateralBrandStatement);
  //   console.log("Theme Colour:", themeColour);

  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Extract the 'collateralBrandStatement' and 'themeColour' from JSON
  const collateralBrandStatement =
    brandingContent?.collateralBrandStatement || null;
  const themeColour = brandingContent?.themeColour || "#21cdc0";

  // Find the 'collateral_image.png' and get its base64 content directly
  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const collateralImage = collateralImageItem?.content || null;

  // Find the 'email_banner.png' and get its base64 content directly
  const emailBannerItem = brandingData?.find(
    (item) => item.name === "email_banner"
  );
  const emailBanner = emailBannerItem?.content || null;

  useEffect(() => {
    getAllDepartments();
  }, []);

  const getAllDepartments = () => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
        headers,
      })
      .then((res) => {
        console.log("Res Data", res);
        if (res.data.status != "Failed") {
          setDepartments(res.data.department_list);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box sx={{ width: "100%", mt: 4 }}>
      {/* Footer Bar - Powered by hlthtek */}
      <Box
        sx={{
          bgcolor: themeColour, // Use the extracted themeColour for background color
          color: "white !important", // White text color
          p: 1,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            marginTop: 2, // Margin top for spacing between powered by section and departments
            fontSize: "14px", // Small font size for the departments
          }}
        >
          Departments:{" "}
          {departments.length > 0
            ? departments.map((dept, index) => (
                <span key={index}>
                  {dept.department}
                  {index < departments.length - 1 && " | "}
                </span>
              ))
            : "No Departments"}
        </Box>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ textAlign: "center" }}
        >
          {/* Logo with powered by hlthtek */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" , textTransform: "none", }}>
              Enhanced Patient Care Powered by Hlthtek Digital Healthcare
              Platform (visit: https://www.hlthtek.com )
            </Typography>
          </Grid>

          {/* Footer Logo */}
          <Grid item xs={12}>
            <img
              src={NavLogoFooter}
              alt="hlthtek Logo"
              style={{ height: "30px" }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FooterPdfTemplate;
